<template>
  <div class="toast-container">
    <div class="unsubscribe-btn" @click="unsubscribe">
      <p>Unsubscribe</p>
    </div>

    <div
      class="msg-container"
      :class="{ 'success-bg': isSuccess}"
      v-if="isToastVisible"
    >
      <p>{{ message }}</p>
      <img src="/images/ui/exit-button.png" @click="hideToastNotification" />
    </div>
  </div>
</template>

<script>
import { config } from '../helpers/domain-config';
import { sendOnClick } from '../utils/dataCollection.utils'
import { getLoginURL } from '../utils/redirect.utils'
import { unsubscribe } from '../utils/unsub.utils'
import message from "../utils/unsub.json"

export default {
  data() {
    return {
      message: '',          
      isToastVisible: false,
      isSuccess: false
    }
  },
  methods: {
    unsubscribe() {
      unsubscribe(config.subdomain)
        .then((resp) => {

          if (resp === true) {
            sendOnClick({
              contentName: 'optout',
              redirectUrl: getLoginURL().href
            })
            this.message = message[config.subdomain].success
            this.isSuccess = true
          } else {
            this.message = message[config.subdomain].failed
            this.isSuccess = false
          }
          this.isToastVisible = true
        })
        .catch((err) => {
          this.message = message[config.subdomain].failed
          this.isToastVisible = true
        })
      },
    hideToastNotification() {
      this.isToastVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.toast-container {
  margin-left: 2%;
}

.unsubscribe-btn {
  color: #fff;
  position: absolute;
  bottom: 10px;
  background-color: black;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;

  p {
    margin: 15px 0;
  }
}

.msg-container {
  color: #fff;
  position: absolute;
  bottom: 80px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  justify-content: center;
  background-color: rgb(134, 11, 11);

  img {
    width: 20px;
    margin-left: 17px;
    position: absolute;
    right: 7px;
    top: 5px;
    cursor: pointer;
  }
}

.success-bg {
  background-color: #4bb543 !important;
}
@media screen and (max-width: 680px) {
    .msg-container {
        width: 220px;
    }
  }
</style>
